<template>
  <div class="logout-state">
    <div id="loaderspinwrap" class="loaderspinwrap"><div class="loaderspin"></div></div>

    <h2 class="logout-state__heading">LOGGING OUT</h2>
    <p class="logout-state__copywriting">Terima kasih sudah menggunakan SOCO Mask Station Recommendation Machine</p>
  </div>
</template>

<script>
export default {
  name: 'LogoutState',
};
</script>
